import React from "react";
import { AnimatePresence, motion } from 'framer-motion';
import MediaRenderer from '../../../../core/components/MediaRenderer';
import { AssetType } from '../../../../../utils/storage';
import { NIKE_EASE } from '../../../../rise/constants/nikerise';
import { DEFAULT_CAROUSEL_ITEM_DURATION_S, DEFAULT_TRANSITION_DURATION } from '../ServiceMenuChapter.constants';

type QrProps = {
    media: AssetType,
    title?: string,
    subtitle?: string,
    delay?: number,
    duration?: number,
    scrim?: boolean,
};

export default function SectionQr(props: QrProps) {
    const {
        media,
        title,
        subtitle,
        delay = DEFAULT_CAROUSEL_ITEM_DURATION_S,
        duration = DEFAULT_TRANSITION_DURATION,
        scrim = true,
    } = props;

    return (
        <AnimatePresence>
            <motion.div
                style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: scrim ? 'rgba(0, 0, 0, 0.7)' : undefined,
                    zIndex: 1000,
                }}
                initial={{ opacity: 0 }}
                animate={{
                    opacity: 1,
                    transition: {
                        ease: NIKE_EASE,
                        delay,
                        duration,
                    },
                }}
            >
                <div
                    style={{
                        color: 'white',
                        fontSize: '1.67vh', // 32
                        textAlign: 'center',
                        wordWrap: 'break-word',
                        whiteSpace: 'pre-line',
                    }}
                >
                    <div
                        style={{
                            width: '14.9vh', // 286px
                            height: '14.9vh', // 286px
                            borderRadius: '1.04vh', // 20px
                            overflow: 'hidden',
                            margin: '0 auto 1.41vh', // 0 auto 27px
                        }}
                    >
                        <MediaRenderer media={media} cover='fill' />
                    </div>

                    {title ? (
                        <p style={{
                            marginBottom: '0.52vh', // 10px
                            fontFamily: 'HelveticaNowDisplay',
                            fontWeight: '700',
                            textTransform: 'uppercase',
                            lineHeight: '1.82vh', // 35px
                            letterSpacing: '0.03vh', // 0.64px
                        }}>{title}</p>
                    ) : null}
                    {subtitle ? (
                        <div style={{
                            fontFamily: 'HelveticaNowText',
                            fontWeight: '400',
                            lineHeight: '2.17vh', // 41.60px
                        }}>{subtitle}</div>
                    ) : null}
                </div>
            </motion.div>
        </AnimatePresence>
    )
}
